var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10957 2.18765C4.20445 2.06904 4.34811 2 4.5 2H13.5C14.3284 2 15 2.67157 15 3.5V11.5C15 12.3284 14.3284 13 13.5 13H4.5C4.34811 13 4.20445 12.931 4.10957 12.8123L0.109566 7.81235C-0.0365219 7.62974 -0.0365219 7.37026 0.109566 7.18765L4.10957 2.18765ZM10.1465 9.85356L8.50004 8.20711L6.85359 9.85356L6.14648 9.14645L7.79293 7.50001L6.14648 5.85356L6.85359 5.14645L8.50004 6.7929L10.1465 5.14645L10.8536 5.85356L9.20714 7.50001L10.8536 9.14645L10.1465 9.85356Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.a9775920be2c1ca5c815f8b20616669d.svg";
export { ForwardRef as ReactComponent };